import { realApi } from './api';

export const login = ({ usuario, password }) => realApi.post('/auth/login', { usuario, password });
export const logout = () => realApi.post('/auth/logout');
export const quienSoy = () => realApi.get('/auth/yo');

// Primer acceso con contraseña temporal: la sesión ya existe tras el login.
export const cambiarPassword = ({ passwordActual, passwordNueva }) =>
  realApi.post('/auth/cambiar-password', { passwordActual, passwordNueva });
